import React from "react";
import "./TCPerformance.css";
import TCPerformanceOverview from "./TCPerformanceOverview";
import Teacher from "../../../assets/other_image/heath_hekup.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const TCPerformance = () => {
  return (
    <>
      <Helmet>
        <title>
          Teamcenter Performance Tuning & Health Check-up Services in Pune | NexTech PLM
        </title>
        <meta
          name="description"
          content="Optimize your Teamcenter system with expert Performance Tuning and Health Check-up services in Pune, India. Ensure smooth PLM operations with Nextech PLM."
        />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
      </Helmet>

      <section className="TCPerformance-management">
        <Banner
          image={Teacher} // Pass the image for this page
          heading="Teamcenter Performance Tuning & Heath Check-up" // Pass the heading text for this page
        />
        <div>
          <FloatingContactUs />
        </div>

        <TCPerformanceOverview />

        <section>
          <div className="health-checkup container">
            <h4 className="TCPerformance-page-heading">Health Checkup</h4>
            <p className="plmimplementationparagraph">
              It’s a process of understanding the health of every system component
              involved in Teamcenter Deployment Architecture with the intension of
              analyzing various components at OS, Software & Hardware level like
              Database server, Pool Server, Web Application Server, Translation Server,
              FMS Server, Licensing server along with client machine  & network for
              configuration, abnormality and performance against the benchmark test
              cases (Which get evolved during performance tuning). 
            </p>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="TCPerformance-page-heading">Unlock the Power :</h4>
            <h5 className="TCPerformance-subheading">
              Discover the Transformative Benefits of Teamcenter Performance Tuning & Heath
              Check-up with NexTech!
            </h5>
            <ul className="custom-bullets">
              <li>Improved system performance by rectifying performance bottlenecks</li>
              <li>
                Improved system stability by rectifying incorrect usage and stability issues
              </li>
              <li>Eliminate the potential issues well in advance</li>
              <li>
                Right input on deciding system scalability at various component levels
                based on performance threshold
              </li>
              <li>
                Help with the planning of maintenance, support, upgrades, and changes to
                the environment configuration
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h4 className="TCPerformance-page-heading">Teamcenter Solutions</h4>

                  <ul className="custom-bullets">
                    <li>Identification of Benchmark Test Cases </li>
                    <li>Test Case Execution and System Monitoring </li>
                    <li>Result Comparison and Analysis </li>
                    <li>Examination of System Architecture and Components</li>
                    <li>Reporting and Recommendations </li>
                  </ul>
                </div>

                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <NavLink to="/teamcenter-ecad-integration">
                          ECAD Integration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-mcad-integration">
                          MCAD Integration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cybersecurity">
                          Teamcenter Cyber security
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-manufacturing-data-process-management">
                          Manufacturing Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-plm-erp-data-process-management">
                          PLM - ERP (SAP, Oracle, HANA) Data and Process
                          Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-bom-management">
                          Product BOM and Variability Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-program-project-management">
                          Teamcenter Project Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-business-process-management">
                          Business Processes & Change Management
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="best-practices container">
            <h4 className="TCPerformance-page-heading">What We Perform</h4>
            <ul className="custom-bullets">
              <li>Identify the benchmark test cases </li>
              <li>
                Run the test cases and monitor the system components like pool manager,
                database server, FMS server, and web application server
              </li>
              <li>Compare the result </li>
              <li>
                Find out any deviation and perform root cause analysis to uncover the
                causing system element
              </li>
              <li>
                Examine the system architecture, Hardware, and Software Environments,
                Setting and Configuration of various components like Teamcenter Server,
                Database Server, network, relevant logs, integration and event log, load
                time, response time, and other relevant factors
              </li>
              <li>
                Delivers report of findings and recommended actions to mitigate any system
                issue uncovered like system maintenance plan, infrastructure enhancement,
                optimization setting, etc.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="why-nextech container">
            <h4 className="TCPerformance-page-heading">Why NexTech?</h4>
            <h5 className="TCPerformance-subheading">
              For Teamcenter Performance Tuning & Health Check-up
            </h5>
            <ul className="custom-bullets">
              <li>
                Expertise in Performance Problem Solving: We possess the expertise to
                identify, analyze, and solve performance issues in Teamcenter systems
                efficiently.
              </li>
              <li>
                Involvement of Right Experts: We ensure that the right people with the
                necessary expertise are involved in the performance monitoring and health
                check-up process, reducing time and costs.
              </li>
              <li>
                Comprehensive Analysis of System Components: We conduct a thorough
                examination of various system components at OS, software, and hardware
                levels, including database servers, web application servers, and client
                machines.
              </li>
              <li>
                Proactive Issue Mitigation: Our process helps to uncover and eliminate
                potential issues well in advance, ensuring improved system performance and
                stability.
              </li>
              <li>
                Strategic Planning Support: We provide valuable input for decision-making
                regarding system scalability, maintenance, support, upgrades, and
                environment configuration, based on performance thresholds and findings.
              </li>
            </ul>
          </div>
        </section>

        <Letsgetintouch />
      </section>
    </>
  );
};

export default TCPerformance;
